<!-- v1.5 -->

<template>
  <div id="ddabbCollectionGrid">
    <div class="container-fluid">
      <div class="product-grid-intro">
        <div class="row">
          <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2 text-center">
            <h1 class="display-3">Packs + Duffels</h1>
            <p class="lead">
              Colorful, go-anywhere travel gear that’s flexible enough to
              replace your luggage and durable enough to never let you down.
            </p>
          </div>
          <!-- .col -->
        </div>
        <!-- row -->
      </div>
      <!-- .product-grid-intro -->
      <div class="product-grid" id="anchor-dd-product-grid-1">
        <div class="row">
          <!-- ========== MINIMIZED GRID 1  ========== -->
          <div
            v-for="(product, index) in productsGroup('packduffel').slice(0, 5)"
            class="col-sm-6 col-lg-4"
          >
            <a :href="product.url" class="ctpx-product-item">
              <div class="product-image">
                <img
                  :src="product.featuredImage"
                  draggable="false"
                  :id="'prod' + product.shopifyProductId"
                  class="img-responsive"
                  width="400"
                  height="400"
                />
                <img
                  v-if="product.alternateImage != null"
                  :src="product.alternateImage.url"
                  draggable="false"
                  class="img-responsive hover-show"
                  width="400"
                  height="400"
                />
                <span
                  v-if="
                    product.isChoiceProduct &&
                    product.choiceInventory === 'choice'
                  "
                  class="btn btn-default"
                  >Choose Color</span
                >
                <span v-else class="btn btn-default">Surprise Me</span>
              </div>
              <!-- .product-image -->
              <div class="product-details">
                <div class="row">
                  <div class="col-8 col-sm-9">
                    <h6 class="product-title">{{ product.title }}</h6>
                    <p class="product-desc">
                      {{ product.shortDescription }}
                      <span>{{ product.shortDescriptionEmphasis }}</span>
                    </p>
                  </div>
                  <!-- .col -->
                  <div class="col-4 col-sm-3 text-right">
                    <h6 class="product-price">
                      {{ formatPrice(product.price) }}
                    </h6>
                  </div>
                  <!-- .col -->
                </div>
                <!-- .row -->
              </div>
              <!-- .product-details --> </a
            ><!-- .ctpx-product-item -->
          </div>
          <!-- .col -->
          <div class="col-sm-6 col-lg-4 mobile-hidden">
            <div
              class="ctpx-non-product-item"
              style="
                background-image: url(https://cdn.shopify.com/s/files/1/0281/7544/files/Del-Dia-Elementscw.jpg);
              "
            >
              <p class="h2">Del Día Dark</p>
              <p class="display-5">
                Allpa 35L Travel Pack now available. Inspired by lava rocks &
                starry skies.
              </p>
              <a href="/collections/del-dia-limited"
                ><button class="btn btn-white">SHOP DARK</button></a
              >
            </div>
            <!-- .ctpx-non-product-item -->
          </div>
          <!-- .col-sm-6 -->
          <!-- ========== MAXIMIZED GRID 1  ========== -->
          <div
            v-if="showMore"
            v-for="(product, index) in productsGroup('packduffel').slice(5)"
            class="col-sm-6 col-lg-4"
          >
            <a :href="product.url" class="ctpx-product-item">
              <div class="product-image">
                <img
                  :src="product.featuredImage"
                  draggable="false"
                  :id="'prod' + product.shopifyProductId"
                  class="img-responsive"
                  width="400"
                  height="400"
                />
                <img
                  v-if="product.alternateImage != null"
                  :src="product.alternateImage.url"
                  draggable="false"
                  class="img-responsive hover-show"
                  width="400"
                  height="400"
                />
                <span
                  v-if="
                    product.isChoiceProduct &&
                    product.choiceInventory === 'choice'
                  "
                  class="btn btn-default"
                  >Choose Color</span
                >
                <span v-else class="btn btn-default">Surprise Me</span>
              </div>
              <!-- .product-image -->
              <div class="product-details">
                <div class="row">
                  <div class="col-8 col-sm-9">
                    <h6 class="product-title">{{ product.title }}</h6>
                    <p class="product-desc">
                      {{ product.shortDescription }}
                      <span>{{ product.shortDescriptionEmphasis }}</span>
                    </p>
                  </div>
                  <!-- .col -->
                  <div class="col-4 col-sm-3 text-right">
                    <h6 class="product-price">
                      {{ formatPrice(product.price) }}
                    </h6>
                  </div>
                  <!-- .col -->
                </div>
                <!-- .row -->
              </div>
              <!-- .product-details --> </a
            ><!-- .ctpx-product-item -->
          </div>
          <!-- .col -->
        </div>
        <!-- .row -->
        <div class="row">
          <div class="col text-center">
            <button
              v-if="!showMore"
              class="btn btn-default load-more"
              v-on:click="showMore = !showMore"
            >
              Load More
            </button>
          </div>
          <!-- .col -->
        </div>
        <!-- .row -->
      </div>
      <!-- .product-grid -->

      <div
        class="ctpx-mobile-blockquote"
        style="
          background-image: url(https://cdn.shopify.com/s/files/1/0281/7544/files/dd-bag-testimonial-bg-f23.jpg?v=1695935426);
        "
      >
        <blockquote>
          <p>
            "Bag quality and craftsmanship are on point. It’s durable, and made
            to last."
          </p>
          <cite>Rebecca B</cite>
        </blockquote>
      </div>
      <!-- .ctpx-mobile-blockquote -->

      <!-- ========== SECOND GRID  ========== -->

      <div class="product-grid-intro">
        <div class="row">
          <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2 text-center">
            <h1 class="display-3">Small Bags + Organization</h1>
            <p class="lead">
              Everyday essentials and travel companions to keep you organized
              and ready for your next adventure.
            </p>
          </div>
          <!-- .col -->
        </div>
        <!-- row -->
      </div>
      <!-- .product-grid-intro -->
      <div class="product-grid" id="anchor-dd-product-grid-2">
        <div class="row">
          <!-- ========== MINIMIZED GRID 2  ========== -->
          <div
            v-for="(product, index) in productsGroup(
              'smallbagsorganization'
            ).slice(0, 3)"
            class="col-sm-6 col-lg-4"
          >
            <a :href="product.url" class="ctpx-product-item">
              <div class="product-image">
                <img
                  :src="product.featuredImage"
                  draggable="false"
                  :id="'prod' + product.shopifyProductId"
                  class="img-responsive"
                  width="400"
                  height="400"
                />
                <img
                  v-if="product.alternateImage != null"
                  :src="product.alternateImage.url"
                  draggable="false"
                  class="img-responsive hover-show"
                  width="400"
                  height="400"
                />
                <span
                  v-if="
                    product.isChoiceProduct &&
                    product.choiceInventory === 'choice'
                  "
                  class="btn btn-default"
                  >Choose Color</span
                >
                <span v-else class="btn btn-default">Surprise Me</span>
              </div>
              <!-- .product-image -->
              <div class="product-details">
                <div class="row">
                  <div class="col-8 col-sm-9">
                    <h6 class="product-title">{{ product.title }}</h6>
                    <p class="product-desc">
                      {{ product.shortDescription }}
                      <span>{{ product.shortDescriptionEmphasis }}</span>
                    </p>
                  </div>
                  <!-- .col -->
                  <div class="col-4 col-sm-3 text-right">
                    <h6 class="product-price">
                      {{ formatPrice(product.price) }}
                    </h6>
                  </div>
                  <!-- .col -->
                </div>
                <!-- .row -->
              </div>
              <!-- .product-details --> </a
            ><!-- .ctpx-product-item -->
          </div>
          <!-- .col -->
          <div class="col-sm-6 col-lg-4 mobile-hidden">
            <div
              class="ctpx-non-product-item justify-content-start"
              style="
                background-image: url(https://cdn.shopify.com/s/files/1/0281/7544/files/BTS24-cw.png);
              "
            >
              <p class="h2 text-black">Little Packs for Little Llamas</p>
              <div class="col-10">
                <p class="text-black">
                  <strong>
                    100% recycled backpacks & <br />lunch bags just for the
                    kiddos
                  </strong>
                </p>
              </div>
              <a href="/collections/back-to-school-packs"
                ><button class="btn btn-white">SHOP BACK TO SCHOOL</button></a
              >
            </div>
            <!-- .ctpx-non-product-item -->
          </div>
          <!-- .col-sm-6 -->
          <div
            v-for="(product, index) in productsGroup(
              'smallbagsorganization'
            ).slice(3, 5)"
            class="col-sm-6 col-lg-4"
          >
            <a :href="product.url" class="ctpx-product-item">
              <div class="product-image">
                <img
                  :src="product.featuredImage"
                  draggable="false"
                  :id="'prod' + product.shopifyProductId"
                  class="img-responsive"
                  width="400"
                  height="400"
                />
                <img
                  v-if="product.alternateImage != null"
                  :src="product.alternateImage.url"
                  draggable="false"
                  class="img-responsive hover-show"
                  width="400"
                  height="400"
                />
                <span
                  v-if="
                    product.isChoiceProduct &&
                    product.choiceInventory === 'choice'
                  "
                  class="btn btn-default"
                  >Choose Color</span
                >
                <span v-else class="btn btn-default">Surprise Me</span>
              </div>
              <!-- .product-image -->
              <div class="product-details">
                <div class="row">
                  <div class="col-8 col-sm-9">
                    <h6 class="product-title">{{ product.title }}</h6>
                    <p class="product-desc">
                      {{ product.shortDescription }}
                      <span>{{ product.shortDescriptionEmphasis }}</span>
                    </p>
                  </div>
                  <!-- .col -->
                  <div class="col-4 col-sm-3 text-right">
                    <h6 class="product-price">
                      {{ formatPrice(product.price) }}
                    </h6>
                  </div>
                  <!-- .col -->
                </div>
                <!-- .row -->
              </div>
              <!-- .product-details --> </a
            ><!-- .ctpx-product-item -->
          </div>
          <!-- .col -->
          <!-- ========== MAXIMIZED GRID 2  ========== -->
          <div
            v-if="showMoreTwo"
            v-for="(product, index) in productsGroup(
              'smallbagsorganization'
            ).slice(5)"
            class="col-sm-6 col-lg-4"
          >
            <a :href="product.url" class="ctpx-product-item">
              <div class="product-image">
                <img
                  :src="product.featuredImage"
                  draggable="false"
                  :id="'prod' + product.shopifyProductId"
                  class="img-responsive"
                  width="400"
                  height="400"
                />
                <img
                  v-if="product.alternateImage != null"
                  :src="product.alternateImage.url"
                  draggable="false"
                  class="img-responsive hover-show"
                  width="400"
                  height="400"
                />
                <span
                  v-if="
                    product.isChoiceProduct &&
                    product.choiceInventory === 'choice'
                  "
                  class="btn btn-default"
                  >Choose Color</span
                >
                <span v-else class="btn btn-default">Surprise Me</span>
              </div>
              <!-- .product-image -->
              <div class="product-details">
                <div class="row">
                  <div class="col-8 col-sm-9">
                    <h6 class="product-title">{{ product.title }}</h6>
                    <p class="product-desc">
                      {{ product.shortDescription }}
                      <span>{{ product.shortDescriptionEmphasis }}</span>
                    </p>
                  </div>
                  <!-- .col -->
                  <div class="col-4 col-sm-3 text-right">
                    <h6 class="product-price">
                      {{ formatPrice(product.price) }}
                    </h6>
                  </div>
                  <!-- .col -->
                </div>
                <!-- .row -->
              </div>
              <!-- .product-details --> </a
            ><!-- .ctpx-product-item -->
          </div>
          <!-- .col -->
        </div>
        <!-- .row -->
        <div class="row">
          <div class="col text-center">
            <button
              v-if="!showMoreTwo"
              class="btn btn-default load-more"
              v-on:click="showMoreTwo = !showMoreTwo"
            >
              Load More
            </button>
          </div>
          <!-- .col -->
        </div>
        <!-- .row -->
      </div>
      <!-- .product-grid -->
    </div>
    <!-- .container-fluid -->
  </div>
</template>

<script src="./ctrl-ddabb-collection-grid.js"></script>
